export default (t) => ({
  element: 'bpmn:ServiceTask',
  service: 'max',
  title: t('script.controlls.max.title'),
  helplink: '',
  group: 'communication',
  class: 'other',
  color: '#60a5c0',
  border: 2,
  icon: 'anticon-icon social-max',
  icon_scale: 1.1,
  offset_x: 6,
  offset_y: -12,
  toolbar_offset_x: 6,
  toolbar_offset_y: -9,
  icon_rotate: 0,
  priority: 11,
  config: [
    {
      id: 'commonSection',
      name: t('script.common.general'),
      type: 'group',
    },
    {
      id: 'name',
      name: t('script.common.title'),
      type: 'text',
      readOnly: false,
      config: {
        defaultEmptyValue: t('script.controlls.max.title'),
        type: 'text',
        valueType: 'const',
        map: 'input',
      },
    },
    {
      id: 'description',
      name: t('script.common.description'),
      type: 'text',
      readOnly: false,
      config: {
        type: 'multiline',
        valueType: 'const',
        map: 'input',
      },
    },

    // ─── Подключение ────────────────────────────────────────────────────────
    {
      id: 'section_connection',
      name: t('script.controlls.max.sectionConnection'),
      type: 'group',
    },
    {
      id: 'service',
      name: t('script.controlls.max.service'),
      type: 'object',
      readOnly: false,
      config: {
        catalogId: '$authServices',
        multiselect: false,
        enableCreate: true,
        enableSelect: true,
        view: 'list',
        map: 'input',
      },
    },

    // ─── Параметры ──────────────────────────────────────────────────────────
    {
      id: 'section_parameters',
      name: t('script.controlls.max.sectionParameters'),
      type: 'group',
    },
    {
      id: 'action',
      name: t('script.controlls.max.action'),
      type: 'radiobutton',
      readOnly: false,
      config: {
        items: [
          { id: 'sendMessage', name: t('script.controlls.max.sendMessage') },
          { id: 'sendLocation', name: t('script.controlls.max.sendLocation') },
          { id: 'sendContact', name: t('script.controlls.max.sendContact') },
          { id: 'forwardMessage', name: t('script.controlls.max.forwardMessage') },
          { id: 'editMessage', name: t('script.controlls.max.editMessage') },
          { id: 'deleteMessage', name: t('script.controlls.max.deleteMessage') },
          { id: 'getChats', name: t('script.controlls.max.getChats') },
          { id: 'getMessages', name: t('script.controlls.max.getMessages') },
          { id: 'answerCallback', name: t('script.controlls.max.answerCallback') },
          { id: 'getMembers', name: t('script.controlls.max.getMembers') },
          { id: 'addMembers', name: t('script.controlls.max.addMembers') },
          { id: 'removeMember', name: t('script.controlls.max.removeMember') },
          { id: 'getSubscriptions', name: t('script.controlls.max.getSubscriptions') },
          { id: 'subscribe', name: t('script.controlls.max.subscribe') },
          { id: 'unsubscribe', name: t('script.controlls.max.unsubscribe') },
          { id: 'getBotInfo', name: t('script.controlls.max.getBotInfo') },
          { id: 'uploadFile', name: t('script.controlls.max.uploadFile') },
        ],
        type: 'select',
        map: 'input',
        defaultEmptyValue: 'sendMessage',
      },
    },
    {
      id: 'callbackId',
      name: t('script.controlls.max.callbackId'),
      type: 'text',
      readOnly: false,
      config: {
        map: 'input',
        type: 'text',
        theme: 'script',
        placeholder: t('script.common.valueExpression'),
      },
      visible: {
        action: { $include: 'answerCallback' },
      },
    },

    // ─── Получатель ─────────────────────────────────────────────────────────
    {
      id: 'chatType',
      name: t('script.controlls.max.chatType'),
      type: 'dropdown',
      readOnly: false,
      config: {
        items: [
          { id: 'chat', name: t('script.controlls.max.chatTypeChat'), color: 'DFE0E0' },
          { id: 'user', name: t('script.controlls.max.chatTypeUser'), color: 'DFE0E0' },
        ],
        defaultValue: true,
        multiselect: false,
        defaultEmptyValue: ['chat'],
        map: 'input',
      },
      visible: {
        action: {
          $in: ['sendMessage', 'sendLocation', 'sendContact', 'forwardMessage'],
        },
      },
    },
    {
      id: 'chatId',
      name: t('script.controlls.max.chatId'),
      type: 'text',
      readOnly: false,
      config: {
        map: 'input',
        type: 'text',
        theme: 'script',
        placeholder: t('script.common.valueExpression'),
      },
      visible: {
        action: {
          $in: [
            'sendMessage',
            'sendLocation',
            'sendContact',
            'forwardMessage',
            'getMessages',
            'getMembers',
            'addMembers',
            'removeMember',
          ],
        },
      },
    },
    {
      id: 'currentChatId',
      name: t('script.controlls.max.currentChatId'),
      hint: t('script.controlls.max.currentChatIdHint'),
      type: 'text',
      readOnly: false,
      config: {
        map: 'input',
        type: 'text',
        theme: 'script',
        placeholder: t('script.common.valueExpression'),
      },
      visible: {
        action: {
          $in: ['getChats'],
        },
      },
    },
    // ─── forwardMessage / editMessage / deleteMessage ───────────────────────
    {
      id: 'messageId',
      name: t('script.controlls.max.messageId'),
      hint: t('script.controlls.max.messageIdHint'),
      type: 'text',
      readOnly: false,
      config: {
        map: 'input',
        type: 'text',
        theme: 'script',
        placeholder: t('script.common.valueExpression'),
      },
      visible: {
        action: { $in: ['forwardMessage', 'editMessage', 'deleteMessage'] },
      },
    },
    // ─── getMessages ────────────────────────────────────────────────────────
    {
      id: 'messageIds',
      name: t('script.controlls.max.messageIds'),
      hint: t('script.controlls.max.messageIdsHint'),
      type: 'text',
      readOnly: false,
      config: {
        map: 'input',
        type: 'text',
        theme: 'script',
        placeholder: t('script.common.valueExpression'),
      },
      visible: {
        action: { $include: 'getMessages' },
      },
    },

    {
      id: 'from',
      name: t('script.controlls.max.from'),
      hint: t('script.controlls.max.fromHint'),
      type: 'text',
      readOnly: false,
      config: {
        map: 'input',
        type: 'text',
        theme: 'script',
        placeholder: t('script.common.valueExpression'),
      },
      visible: {
        action: { $include: 'getMessages' },
      },
    },
    {
      id: 'to',
      name: t('script.controlls.max.to'),
      hint: t('script.controlls.max.toHint'),
      type: 'text',
      readOnly: false,
      config: {
        map: 'input',
        type: 'text',
        theme: 'script',
        placeholder: t('script.common.valueExpression'),
      },
      visible: {
        action: { $include: 'getMessages' },
      },
    },

    // ─── sendMessage ────────────────────────────────────────────────────────
    {
      id: 'text',
      name: t('script.controlls.max.text'),
      type: 'text',
      readOnly: false,
      config: {
        type: 'multiline',
        map: 'input',
        theme: 'script',
        placeholder: t('script.common.valueExpression'),
      },
      visible: {
        action: { $in: ['sendMessage', 'editMessage', 'answerCallback'] },
      },
    },
    {
      id: 'format',
      name: t('script.controlls.max.format'),
      type: 'dropdown',
      readOnly: false,
      config: {
        items: [
          { id: 'none', name: t('script.controlls.max.formatNone'), color: 'DFE0E0' },
          { id: 'markdown', name: 'Markdown', color: 'DFE0E0' },
          { id: 'html', name: 'HTML', color: 'DFE0E0' },
        ],
        defaultValue: true,
        multiselect: false,
        defaultEmptyValue: ['none'],
        map: 'input',
      },
      visible: {
        action: { $in: ['sendMessage', 'editMessage', 'answerCallback'] },
      },
    },
    // ─── sendLocation ───────────────────────────────────────────────────────
    {
      id: 'location',
      name: t('script.controlls.max.location'),
      hint: t('script.controlls.max.locationHint'),
      type: 'text',
      readOnly: false,
      config: {
        type: 'multiline',
        map: 'input',
        theme: 'script',
        placeholder: t('script.common.valueExpression'),
      },
      visible: {
        action: { $include: 'sendLocation' },
      },
    },
    // ─── sendContact ────────────────────────────────────────────────────────
    {
      id: 'contact',
      name: t('script.controlls.max.contact'),
      hint: t('script.controlls.max.contactHint'),
      type: 'text',
      readOnly: false,
      config: {
        type: 'multiline',
        map: 'input',
        theme: 'script',
        placeholder: t('script.common.valueExpression'),
      },
      visible: {
        action: { $include: 'sendContact' },
      },
    },
    {
      id: 'attachments',
      name: t('script.controlls.max.attachments'),
      hint: t('script.controlls.max.attachmentsHint'),
      type: 'text',
      readOnly: false,
      config: {
        map: 'input',
        type: 'multiline',
        theme: 'script',
        placeholder: t('script.common.valueExpression'),
      },
      visible: {
        action: { $in: ['sendMessage', 'editMessage', 'answerCallback'] },
      },
    },
    {
      id: 'buttons',
      name: t('script.controlls.max.buttons'),
      hint: t('script.controlls.max.buttonsHint'),
      type: 'text',
      readOnly: false,
      config: {
        type: 'multiline',
        map: 'input',
        theme: 'script',
        placeholder: t('script.common.valueExpression'),
      },
      visible: {
        action: { $in: ['sendMessage', 'sendLocation', 'sendContact', 'editMessage', 'answerCallback'] },
      },
    },
    // ─── answerCallback ─────────────────────────────────────────────────────
    {
      id: 'notification',
      name: t('script.controlls.max.notification'),
      hint: t('script.controlls.max.notificationHint'),
      type: 'text',
      readOnly: false,
      config: {
        map: 'input',
        type: 'text',
        theme: 'script',
        placeholder: t('script.common.valueExpression'),
      },
      visible: {
        action: { $include: 'answerCallback' },
      },
    },
    // ─── Reply ──────────────────────────────────────────────────────────────
    {
      id: 'reply',
      name: t('script.controlls.max.reply'),
      type: 'switch',
      readOnly: false,
      config: { defaultEmptyValue: false },
      visible: {
        action: { $in: ['sendMessage', 'sendLocation', 'sendContact', 'editMessage', 'answerCallback'] },
      },
    },
    {
      id: 'replyMessageId',
      name: t('script.controlls.max.replyMessageId'),
      type: 'text',
      readOnly: false,
      config: {
        map: 'input',
        type: 'text',
        theme: 'script',
        placeholder: t('script.common.valueExpression'),
      },
      visible: {
        reply: { $include: true },
      },
    },
    {
      id: 'notify',
      name: t('script.controlls.max.notify'),
      type: 'switch',
      readOnly: false,
      config: { defaultEmptyValue: false },
      visible: {
        action: { $in: ['sendMessage', 'sendLocation', 'sendContact', 'forwardMessage', 'editMessage', 'answerCallback'] },
      },
    },

    // ─── getUsers / addUsers ─────────────────────────────────────────────────────────
    {
      id: 'getUsersIds',
      name: t('script.controlls.max.getUsersIds'),
      hint: t('script.controlls.max.getUsersIdsHint'),
      type: 'text',
      readOnly: false,
      config: {
        map: 'input',
        type: 'text',
        theme: 'script',
        placeholder: t('script.common.valueExpression'),
      },
      visible: {
        action: { $in: ['getMembers'] },
      },
    },
    {
      id: 'addUsersIds',
      name: t('script.controlls.max.addUsersIds'),
      hint: t('script.controlls.max.addUsersIdsHint'),
      type: 'text',
      readOnly: false,
      config: {
        map: 'input',
        type: 'text',
        theme: 'script',
        placeholder: t('script.common.valueExpression'),
      },
      visible: {
        action: { $in: ['addMembers'] },
      },
    },

    // ─── removeUser ───────────────────────────────────────────────────────
    {
      id: 'userId',
      name: t('script.controlls.max.userId'),
      hint: t('script.controlls.max.userIdHint'),
      type: 'text',
      readOnly: false,
      config: {
        map: 'input',
        type: 'text',
        theme: 'script',
        placeholder: t('script.common.valueExpression'),
      },
      visible: {
        action: { $include: 'removeMember' },
      },
    },

    // ─── subscribe / unsubscribe ─────────────────────────────────────────────
    {
      id: 'webhookUrl',
      name: t('script.controlls.max.webhookUrl'),
      hint: t('script.controlls.max.webhookUrlHint'),
      type: 'text',
      readOnly: false,
      config: {
        map: 'input',
        type: 'text',
        theme: 'script',
        placeholder: t('script.common.valueExpression'),
      },
      visible: {
        action: { $in: ['subscribe', 'unsubscribe'] },
      },
    },
    {
      id: 'updateTypes',
      name: t('script.controlls.max.updateTypes'),
      hint: t('script.controlls.max.updateTypesHint'),
      type: 'text',
      readOnly: false,
      config: {
        map: 'input',
        type: 'text',
        theme: 'script',
        placeholder: t('script.common.valueExpression'),
      },
      visible: {
        action: { $include: 'subscribe' },
      },
    },
    {
      id: 'webhookSecret',
      name: t('script.controlls.max.webhookSecret'),
      hint: t('script.controlls.max.webhookSecretHint'),
      type: 'text',
      readOnly: false,
      config: {
        map: 'input',
        type: 'text',
        theme: 'script',
        placeholder: t('script.common.valueExpression'),
      },
      visible: {
        action: { $include: 'subscribe' },
      },
    },

    // ─── getMessages / getChats / getMembers ─────────────────────────────────
    {
      id: 'limit',
      name: t('script.controlls.max.limit'),
      hint: t('script.controlls.max.limitHint'),
      type: 'text',
      readOnly: false,
      config: {
        map: 'input',
        type: 'text',
        theme: 'script',
        placeholder: t('script.common.valueExpression'),
      },
      visible: {
        action: { $in: ['getMessages', 'getChats', 'getMembers'] },
      },
    },
    {
      id: 'marker',
      name: t('script.controlls.max.marker'),
      hint: t('script.controlls.max.markerHint'),
      type: 'text',
      readOnly: false,
      config: {
        map: 'input',
        type: 'text',
        theme: 'script',
        placeholder: t('script.common.valueExpression'),
      },
      visible: {
        action: { $in: ['getChats', 'getMembers'] },
      },
    },
    {
      id: 'attachmentsType',
      name: t('script.controlls.max.attachmentsType'),
      type: 'dropdown',
      readOnly: false,
      config: {
        items: [
          { id: 'skip', name: t('script.controlls.max.skip'), color: 'DFE0E0' },
          { id: 'links', name: t('script.controlls.max.links'), color: 'DFE0E0' },
        ],
        defaultValue: true,
        multiselect: false,
        defaultEmptyValue: ['skip'],
        map: 'input',
      },
      visible: {
        action: { $in: ['getMessages'] },
      },
    },

    // ─── uploadFile ─────────────────────────────────────────────────────────
    {
      id: 'fileUrl',
      name: t('script.controlls.max.fileUrl'),
      type: 'text',
      readOnly: false,
      config: {
        map: 'input',
        type: 'text',
        theme: 'script',
        placeholder: t('script.common.valueExpression'),
      },
      visible: {
        action: { $include: 'uploadFile' },
      },
    },
    {
      id: 'fileTitle',
      name: t('script.controlls.max.fileTitle'),
      type: 'text',
      readOnly: false,
      config: {
        map: 'input',
        type: 'text',
        theme: 'script',
        placeholder: t('script.common.valueExpression'),
      },
      visible: {
        action: { $include: 'uploadFile' },
      },
    },

    // ─── Результат ──────────────────────────────────────────────────────────
    {
      id: 'section_output',
      name: t('script.common.result'),
      type: 'group',
      visible: {
        action: {
          $in: [
            'sendMessage',
            'sendLocation',
            'sendContact',
            'forwardMessage',
            'editMessage',
            'deleteMessage',
            'getMessages',
            'getChats',
            'getMembers',
            'getBotInfo',
            'answerCallback',
            'addMembers',
            'removeMember',
            'getSubscriptions',
            'subscribe',
            'unsubscribe',
            'uploadFile',
          ],
        },
      },
    },
    {
      id: 'output_body',
      name: t('script.controlls.max.saveResult'),
      type: 'text',
      readOnly: false,
      config: {
        type: 'text',
        map: 'output',
        placeholder: t('script.common.variableName'),
      },
    },
    {
      id: 'output_marker',
      name: t('script.controlls.max.saveMarker'),
      type: 'text',
      readOnly: false,
      config: {
        type: 'text',
        map: 'output',
        placeholder: t('script.common.variableName'),
      },
      visible: {
        action: { $in: ['getChats', 'getMembers'] },
      },
    },
  ],
  exits: [],
});
